import src from "IMAGE";
export default { src, width: 1440, height: 407, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAQ0lEQVR42g3IuRGAIBBAUWrQwIAZkcMFdkHH/ov7kj73vZNehTsnemtoV8xsWeXYN9wzB8OUEk4u74khEGNCRCgl8wPpJBbnW2RPwgAAAABJRU5ErkJggg=="};
